import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import SignUp from "../components/SignUp";

const Register = () => {
  return (
    <>
      <Navbar />
     <SignUp />
      

      <Footer />
    </>
  );
};

export default Register;
